import { useCallback, useState } from 'react';

import type { QualityDetailDateRange } from '@/entities/quality/domain/type';

import { DATE_OPTIONS } from '@/features/quality/lib/options';

export const useDateOption = () => {
  const [selectedDateValue, setSelectedDateValue] = useState<QualityDetailDateRange>(7);
  const handleSelectDateValue = useCallback((value: QualityDetailDateRange) => {
    setSelectedDateValue(value);
  }, []);

  return {
    DATE_OPTIONS,
    selectedDateValue,
    handleSelectDateValue,
  };
};
